export const setLocalStorage = (name, data) => {
  localStorage.setItem(name, JSON.stringify(data));
  return true;
};
export const getLocalStorage = name => {
  return localStorage.hasOwnProperty(name)
    ? JSON.parse(localStorage.getItem(name))
    : false;
};
export const removeLocalStorage = name => {
  return localStorage.hasOwnProperty(name)
    ? localStorage.removeItem(name)
    : false;
};
